import { ThumbnailSprite } from '@app/core/thumbnails/components/ThumbnailSprite';
import { ThumbnailImageMetadata } from '@app/core/thumbnails/types';
import { WebAppFragmentThumbnailsDto } from '@mi-front/api-v2';
import { Box } from '@mui/material';

export type FragmentCardThumbnailsHoverProps = {
  thumbnails: WebAppFragmentThumbnailsDto;
  frameIndex: number;
};

/**
 * Full-bleed sprite overlay for the fragment card media area.
 * Renders one frame of the thumbnails strip; pointer-events none so card clicks pass through.
 */
export function FragmentCardThumbnailsHover({
  thumbnails,
  frameIndex,
}: FragmentCardThumbnailsHoverProps) {
  const metadata: ThumbnailImageMetadata = thumbnails.metadata;

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      <ThumbnailSprite
        url={thumbnails.thumbnailUrl}
        metadata={metadata}
        frameIndex={frameIndex}
        mode="fill"
      />
    </Box>
  );
}
